module.exports = __webpack_public_path__ + "static/img/2.1.8ec1e67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/2.1.png
// module id = rYC/
// module chunks = 0